var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 10,
    fill: "#0492C2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_97)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29 14.75C26.1816 14.75 23.4265 15.5857 21.0831 17.1516C18.7397 18.7174 16.9133 20.9429 15.8347 23.5468C14.7562 26.1506 14.474 29.0158 15.0238 31.78C15.5737 34.5443 16.9308 37.0834 18.9237 39.0763C20.9166 41.0692 23.4557 42.4263 26.22 42.9762C28.9842 43.526 31.8494 43.2438 34.4532 42.1653C37.0571 41.0867 39.2826 39.2603 40.8484 36.9169C42.4143 34.5735 43.25 31.8184 43.25 29C43.25 25.2207 41.7487 21.5961 39.0763 18.9237C36.4039 16.2513 32.7793 14.75 29 14.75ZM31.375 31.375L21.875 36.125L26.625 26.625L36.125 21.875L31.375 31.375Z",
    fill: "#0492C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 43.25C36.8701 43.25 43.25 36.8701 43.25 29C43.25 21.1299 36.8701 14.75 29 14.75C21.1299 14.75 14.75 21.1299 14.75 29C14.75 36.8701 21.1299 43.25 29 43.25Z",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.125 21.875L26.625 26.625L21.875 36.125L31.375 31.375L36.125 21.875Z",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.bc3fc68980867a295f698fb7a45f1e1c.svg";
export { ForwardRef as ReactComponent };